import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import "./index.css";
import { Icon } from "leaflet";
import s1 from "./s1.svg";
import s2 from "./s2.svg";
import s3 from "./s3.svg";
import s4 from "./s4.svg";
import s5 from "./s5.svg";
import s6 from "./s6.svg";
import s7 from "./s7.svg";
import s8 from "./s8.svg";
import s20 from "./s20.svg";
import { useEffect, useState } from "react";
import { z } from "zod";

const iconMapping: Record<string, string> = {
  s1,
  s2,
  s3,
  s4,
  s5,
  s6,
  s7,
  s8,
  s20,
};

type Train = {
  id: string;
  lat: number;
  lon: number;
  line: string;
  vehicleId: string;
  rake: string;
  expire: Date;
};

const re = new RegExp("94800(\\d*)");

const dataschema = z.object({
  content: z
    .array(
      z.union([
        z.null(),
        z.object({
          content: z.union([
            z.null(),
            z.object({
              properties: z.object({
                raw_coordinates: z.array(z.number()).optional(),
                rake: z.string().nullable(),
                train_id: z.string().optional(),
                line: z
                  .object({
                    name: z.string().optional(),
                  })
                  .nullable(),
              }),
            }),
          ]),
        }),
      ])
    )
    .transform((content) =>
      content
        .map((e) => e?.content?.properties)
        .filter(
          (element) =>
            element !== undefined &&
            element.line !== null &&
            element.raw_coordinates !== undefined &&
            element.rake !== null &&
            element.train_id !== undefined &&
            element.line.name !== undefined
        )
        .map((e) => ({
          ...e,
          line: e!.line!,
          raw_coordinates: e!.raw_coordinates!,
          rake: e!
            .rake!.split(";")
            .filter((e) => e !== "0")
            .map((e) => re.exec(e)![1])
            .map((e) => e.slice(0, 3) + " " + e.slice(3, 6) + "-" + e[6])
            .join(", "),
          train_id: e!.train_id!,
        }))
    ),
});

export function App() {
  const [trains, setTrains] = useState<Train[]>([]);

  useEffect(() => {
    const ws = new WebSocket(
      "wss://api.geops.io/realtime-ws/v1/?key=5cc87b12d7c5370001c1d655112ec5c21e0f441792cfc2fafe3e7a1e"
    );
    const realTrains: Train[] = [];
    ws.onmessage = (ev) => {
      const { data, success } = dataschema.safeParse(JSON.parse(ev.data));
      if (!success) return;
      for (const element of data.content) {
        const [lon, lat] = element.raw_coordinates;
        const id = element.train_id;
        const index = realTrains.findIndex((x) => x.id == id);
        const train = {
          id,
          lat,
          lon,
          line: element.line.name!,
          vehicleId: element.train_id,
          rake: element.rake,
          expire: new Date(Date.now() + 30000),
        };
        if (index < 0) realTrains.push(train);
        else realTrains[index] = train;
      }
      setTrains([...realTrains]);
      // console.log(JSON.stringify(JSON.parse(ev.data), null, 2))
    };

    ws.onopen = (ev) => {
      console.log(ev);
      ws.send("BUFFER 100 100");
      ws.send(
        "BBOX -3532800 -3547844 8423176 5815388 4 tenant=sbm channel_prefix=schematic"
      );
      setInterval(() => ws.send("PING"), 5000);
      setInterval(() => {
        for (let i = realTrains.length - 1; i > 0; i--) {
          if (realTrains[i].expire < new Date()) {
            realTrains.splice(i, 1);
          }
        }
      }, 10000);
    };
  }, []);
  return (
    <div className="w-screen h-screen">
      <MapContainer
        center={[48.137221, 11.575515]}
        zoom={10}
        scrollWheelZoom={true}
        style={{ width: "100%", height: "100%" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {trains.map((x) => (
          <Marker
            position={[x.lat, x.lon]}
            icon={
              new Icon({
                iconUrl: iconMapping[x.line.toLowerCase()],
                iconSize: [50, 50],
              })
            }
          >
            <Popup>Fahrzeugnummer: {x.rake}</Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}

export default App;
